import React from "react";
import Grid from "@mui/material/Grid2"; 
import { Box, Typography, Card, CardContent } from "@mui/material";
import { PensionFundCoverage } from "../../../../interfaces/DTO/mislaka_xml_insurence_models";
import { PolicyOrAccount } from "../../../../interfaces/DTO/mislaka_xml_models";
import { formatCurrency, formatIsoDate } from "../../../../utils/namesFormater";
import { formatYesNo } from "../../../../utils/pensionEnumFormatter";

interface PensionFundCoverageCostsProps {
  policy: PolicyOrAccount;
}

const formatValue = (
  value: string | number | undefined,
  format?: (val: number) => string
): string => {
  if (value === undefined || value === null) return "-";
  if (typeof value === "number" && typeof format === "function") {
    return format(value);
  }
  return value.toString();
};

const PensionFundCoverageCosts: React.FC<PensionFundCoverageCostsProps> = ({ policy }) => {
  const allPensionCoverages: PensionFundCoverage[] = policy.insurence_coverages?.flatMap(
    (coverage) => coverage.coverages || []
  ) || [];

  if (allPensionCoverages.length === 0) return null;

return (
    <Box>
      {allPensionCoverages.map((coverage, index) => {
        const totalMonthlyCost =
          (coverage.disability_coverage_cost || 0) +
          (coverage.disabled_survivor_pension_cost || 0) +
          (coverage.survivors_coverage_cost || 0);

        return (
          <Card key={index} sx={{ mb: 2, p: 2 }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }}>
                עלויות חודשיות כיסוי: {index + 1} | סה"כ: {formatCurrency(totalMonthlyCost)}
              </Typography>

              <Grid container spacing={2}>
                {[
                  {
                    label: "עלות כיסוי נכות",
                    value: coverage.disability_coverage_cost,
                    format: formatCurrency,
                  },
                  {
                    label: "עלות פנסיית שארים של נכה",
                    value: coverage.disabled_survivor_pension_cost,
                    format: formatCurrency,
                  },
                  {
                    label: "עלות כיסוי שארים",
                    value: coverage.survivors_coverage_cost,
                    format: formatCurrency,
                  },
                ].map((item, i) =>
                  item.value !== undefined ? (
                    <React.Fragment key={i}>
                      <Grid size={{ xs: 6, md: 4 }}>
                        <Typography variant="body2" fontWeight="bold">
                          {item.label}:
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 6, md: 8 }}>
                        <Typography>{formatValue(item.value, item.format)}</Typography>
                      </Grid>
                    </React.Fragment>
                  ) : null
                )}

                {coverage.waiver_signature_date && (
                  <>
                    <Grid size={{ xs: 6, md: 4 }}>
                      <Typography variant="body2" fontWeight="bold">
                        תאריך חתימה על ויתור שארים:
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 8 }}>
                      <Typography>{formatIsoDate(coverage.waiver_signature_date)}</Typography>
                    </Grid>
                  </>
                )}

                {coverage.waiver_end_date && (
                  <>
                    <Grid size={{ xs: 6, md: 4 }}>
                      <Typography variant="body2" fontWeight="bold">
                        תאריך סיום ויתור שארים:
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 8 }}>
                      <Typography>{formatIsoDate(coverage.waiver_end_date)}</Typography>
                    </Grid>
                  </>
                )}

                {coverage.insurance_waiver === 1 && (
                  <>
                    <Grid size={{ xs: 6, md: 4 }}>
                      <Typography variant="body2" fontWeight="bold">
                        ויתור על כיסוי ביטוחי לנכות (מעל גיל 60):
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 8 }}>
                      <Typography>{formatYesNo(coverage.insurance_waiver)}</Typography>
                    </Grid>
                  </>
                )}
              </Grid>
            </CardContent>
          </Card>
        );
      })}
    </Box>
  );
};

export default PensionFundCoverageCosts;
